import Vue from "vue"
import VueRouter from 'vue-router' 
Vue.use(VueRouter)

//解决连续多次点击跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
	mode: 'history',
    routes:[
      {
          path: '/',
          name: 'home',
          component: ()=>import('../views/home'),
        },
        {
          path: '/',
          name: 'home',
          component: ()=>import('../views/home'),
        },
        {
          path: '/search',
          name: 'search',
          component: ()=>import('../views/search'),
        },
        {
          path: '/allSolo',
          name: 'allSolo',
          component: ()=>import('../views/allSolo'),
        },
        {
          path: '/soloDtl',
          name: 'soloDtl',
          component: ()=>import('../views/soloDtl'),
        },
        {
          path: '/success1',
          name: 'success1',
          component: ()=>import('../views/success1'),
        },
        {
          path: '/success1Dtl',
          name: 'success1Dtl',
          component: ()=>import('../views/success1Dtl'),
        },
        {
          path: '/success2',
          name: 'success2',
          component: ()=>import('../views/success2'),
        },
        {
          path: '/success3',
          name: 'success3',
          component: ()=>import('../views/success3'),
        },
        {
          path: '/proDtl',
          name: 'proDtl',
          component: ()=>import('../views/proDtl'),
        },
        {
          path: '/service',
          name: 'service',
          component: ()=>import('../views/service'),
        },
        {
          path: '/serviceDtl',
          name: 'serviceDtl',
          component: ()=>import('../views/serviceDtl'),
        },
        {
          path: '/about',
          name: 'about',
          component: ()=>import('../views/about'),
        },
        {
          path: '/rencai',
          name: 'rencai',
          component: ()=>import('../views/rencai'),
        },
        {
          path: '/contact',
          name: 'contact',
          component: ()=>import('../views/contact'),
        },
        {
          path: '/future',
          name: 'future',
          component: ()=>import('../views/future'),
        },
        {
          path: '/allPro',
          name: 'allPro',
          component: ()=>import('../views/allPro'),
        }
        

    ]
})


